<template>
<div>
  <CCard>
      <CCardHeader>
        <CIcon name="cil-filter"/><strong> Filter By User</strong>
      </CCardHeader>
      <CCardBody>
        <CRow class="col-md-12">
                    <CSelect
                    class="col-md-3"
                    :options="user_opt"
                    :value.sync="input.userid"
                    size="sm"
                    placeholder='select'
                    @change="getallData('filter')"
                    />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
    <CCardHeader>
      <CIcon name="cil-grid"/><strong>Traffic Source List</strong>
    </CCardHeader>
    <CCardBody>
      <div v-if="loading==true">Loading . . .</div>
      <div v-else>
      <CRow>
        <CCol>
          <CRow class="col-md-12">
            <label>Filter :</label>
            <CInput class="col-md-8"
            @keyup="customFilter"
            v-model="filter"
            type="search"
            placeholder="Type to Search" />
            <label>Total Rows : {{totalRows}}</label>
          </CRow>
        </CCol>
        <CCol>
      <div class="card-header-actions">
            <small class="text-muted"
              >
        <multiselect
              :limit="2"
              :clear-on-select="false"
              :close-on-select="true"
              :multiple="false"
              :options="perPage"
              :preselect-first="false"
              :preserve-search="false"
              @input="checkPage()"
              placeholder="PerPage"
              v-model="tableperpage"
            ></multiselect></small
            ></div>
      </CCol>
    </CRow>
    <CDataTable
      :items="items"
      :fields="fields"
      :dark="false"
      :items-per-page="tableperpage"
      pagination
      sorter
      hover
      striped
      border
      small
      fixed
      light
    >
    <!-- column-filter -->
    
    <template #action="{item}">
        <td>
          <div class="row col-md-12">
          <span @click="edit(item)">
          <CImg src="img/logo/edit.png" class="ml-1 img-fluid" title="Edit"
                             style="cursor: pointer;"
                             ></CImg>
          </span>
          <span @click="update(item,'hide')">
          <CImg src="img/logo/delelt.png" class="img-fluid ml-1" title="Delete"
          style="cursor: pointer;"
          ></CImg>
          </span>
          <span  @click=update(item)>
            <CImg v-if="item.status == true" src="img/logo/push.png" class="img-fluid ml-1" title="Inactive" :pressed.sync="item.status"
          style="cursor: pointer;"
          ></CImg>
            <CImg v-if="item.status == false" src="img/logo/play.png" class="img-fluid ml-1" title="Active" :pressed.sync="item.status"
              style="cursor: pointer;"
          ></CImg>
          </span>
          </div>
          <!-- <CButton variant="outline" color="success" :pressed.sync="item.status" @click=update(item)>{{item.status ? 'Active ' : 'Deactive'}}</CButton> -->
          
        </td>
      </template>
      </CDataTable>
      </div>
       
    </CCardBody>
    </CCard>
</div>
</template>

<script>
import TrafficService from '../../services/trafficsourceControllservice'
import ManagerService from './../../services/managerControlService'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Multiselect from "vue-multiselect";

const fields = [
        { key: "_id", label: "Id", sortable: true },
        { key: "tsname", label: "Name",sortable: true },
        { key: "useremail", label: "User",sortable: true },
        { key: "conversionUrl", label: "Postback" ,sortable: true},
        // { key: "action", label: "Action" ,sortable: true}
      ]
export default {
  components:{Multiselect},
  name: 'ListOffer',
  props:{small: Boolean},
  data() {
        return {
          users:[],
          input:{userid:''},
          user_opt:[],
          all_data:[],
          filter: '',
          totalRows:0,
          loading:true,
          tableperpage:20,
          perPage:[20,50,100],
          edittraffic:false,
          items:[],
          useremail:'',
          fields,
          startDate: 1325376000000,
          endDate: 1330560000000  
        }
        },
      mounted(){
        if(window.localStorage.getItem('user') && window.localStorage.getItem('status') != 'true'){
          this.$router.push('/')
        }
        else{
        this.useremail = window.localStorage.getItem("email");
        this.getallData();
        if(localStorage.getItem("traffic_table") != null)
        this.tableperpage = parseInt(localStorage.getItem("traffic_table"));
        this.getUsers()
        }
      },
  methods: {
     async getUsers(){
            let response
        try {
            response = await ManagerService.getuser()
            this.users = response.message.filter(t=>{
            if(t.role != 'manager')
            return t
            })
            this.user_opt = this.users.map(m =>  m.email)
        } catch(e){
            console.error("Error in login")
            console.log(e)
        }
        },
    customFilter() {
      let search = this.filter.toString().toLowerCase()
      if(search != ''){
      let f_data = this.all_data.filter(row => row.conversionUrl.match(search) || row.tsname.match(search))
      if(f_data){return this.items = f_data}
      }
      else{return this.items = this.all_data}
    },
    checkPage(){
      localStorage.setItem("traffic_table", this.tableperpage);
    },
    async getallData(txt) {
      try {
        var response
        if(txt){
          response = await TrafficService.tsmanagerget({users: this.input.userid})
          if(response.message == ''){
            Swal.fire({title: 'Error!',text: "Data not available for this user",icon: 'error',confirmButtonText: 'Ok',position: 'top-end',showConfirmButton: false,timer: 1000})
            this.getallData()
          
          }
        }
        else{
          response = await TrafficService.tsmanagerget()
        }
        //   this.users = response.data.message;
        this.items = response.message;
        this.all_data = response.message;
        this.totalRows = this.items.length;
        this.loading = false;
      } catch (e) {
        // Swal.fire({title: 'Error!',text: 'connection error',icon: 'error',confirmButtonText: 'Close',position: 'top-end',showConfirmButton: false,timer: 1000})
        // this.errorNotify("Error", "connection error", "danger");
        //   this.$router.push("Login");
      }
    },
    async edit(data) {
      this.$root.$data.traffic = data;
      this.$root.$data.edit = true;
      this.edittraffic = true;
      this.$router.push('/ts/newts');

    },
  }

}
</script>
